import { render, staticRenderFns } from "./CurriculumVitaeInfo.vue?vue&type=template&id=d4d66066&"
import script from "./CurriculumVitaeInfo.vue?vue&type=script&lang=js&"
export * from "./CurriculumVitaeInfo.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumVitaeInfo.vue?vue&type=style&index=0&id=d4d66066&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports